import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TagPanelDataProviderFactory } from '../factory/TagPanelDataProviderFactory';
import { TagPanelBaseDataProvider } from '../dataProvider/TagPanelBaseDataProvider';
import { TagData } from '../../types/tag-data';
import { DeepPartial } from 'typeorm';

export class TagPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TagPanelDataProviderFactory;
  public dataProvider: TagPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TagPanelDataProviderFactory(),
    });
  }

  public async addTag(payload: DeepPartial<TagData>): Promise<{ success: boolean; errorMessage?: string }> {
    return this.dataProvider.addTag(payload);
  }

  public async updateTag(payload: DeepPartial<TagData>): Promise<{ success: boolean }> {
    return this.dataProvider.updateTag(payload);
  }

  public async getTagById(tagId: string, isClone = false): Promise<TagData> {
    return this.dataProvider.getTagById(tagId, isClone);
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }
}
